'use strict';

var DrillAcrossHelper = {};

var EXPLORE_DASHBOARD_DRILL_ACROSS_ITEMS_ID = 'exploreDashboardDrillAcrossItems'; // hidden div listing the drillacross options at each indention level

/*
 * returns content to be placed in the Explore Menu (drill across to dashboards)
 */
DrillAcrossHelper.createDashboardDrillAcrossMenu = function(indentLevel, link){

    var listItemHtml = '';

    // when we're in a dashboard, each grid (ie each table) will have its own list of drillacross items, so
    // see if we can find the explore data in the sibling nodes
    var exploreDataDiv =  null;
    var row = link.parentNode.parentNode.parentNode;  // it's a link inside a div inside a td inside a tr
    var dashboardTableDiv = row.parentNode.parentNode.parentNode; // row inside a tbody inside a table inside a div
    for(var i = 0; i < dashboardTableDiv.children.length; i++){
        if( dashboardTableDiv.children[i].id === EXPLORE_DASHBOARD_DRILL_ACROSS_ITEMS_ID ){
            exploreDataDiv = dashboardTableDiv.children[i];
        }
    }

    // if the data's not next to us then here's hoping we're on a report and there's just one of it per page
    if(!exploreDataDiv){
        exploreDataDiv  = document.getElementById(EXPLORE_DASHBOARD_DRILL_ACROSS_ITEMS_ID);
    }

    if(exploreDataDiv){
        // parse the list (in order of indention level) of lists of drill across configs
        var indentLevelDataSet = null;
        try{
            indentLevelDataSet = JSON.parse(exploreDataDiv.innerHTML);
        } catch (parseExeption){
            console.error('Unable to parse drill across json. Exception: ' +parseExeption + ' Json: ' + exploreDataDiv.innerHTML);
        }

        if(indentLevelDataSet && indentLevelDataSet.length > indentLevel-1){
            // Get the individual items
            var drillacrossList = indentLevelDataSet[indentLevel-1];

            // find the value at this row for each prompt
            var drillDownDimensions =   row.getAttribute('ids').split(';;;');
            var drillDownValues =  row.getAttribute('idvals').split(';;;');

            listItemHtml = DrillAcrossHelper.generateDrillAcrossHtml(drillacrossList, drillDownDimensions, drillDownValues, indentLevel);
        }
    }

    return listItemHtml;
};

/*
 * Generate the <li> elements for drilling across to dashboards for the currently clicked row or data point
 *
 * drillacrossList - the list of lists of drill across definitions at this indention level that should be added to the menu
 * drillDownDimensions - dimensions on the drill down path to this point
 * drillDownValues - the single values in parallel to drillDownDimensions down to this point
 * indentLevel - the indent level we're at (just for the id of the link)
 */
DrillAcrossHelper.generateDrillAcrossHtml = function(drillacrossList, drillDownDimensions, drillDownValues, indentLevel){
    var listItemHtml = '';
    if(drillacrossList && drillacrossList.length > 0){
        for(var i = 0; i < drillacrossList.length; i++){

            var drillacrossDefinition = drillacrossList[i];

            var url = 'displayFullScreenDashboard.flow?libraryName=' + encodeURIComponent(drillacrossDefinition.dashboardLibrary);
            url += '&id=' + encodeURIComponent(drillacrossDefinition.dashboardId) + '&valuesAreDescriptions=false';

            var promptNames = drillacrossDefinition.promptNames;
            // Note: These are just used to match with identifiers on the current report, they are not necessarily
            // the identifier abbreviations of the prompts, if those prompts are on a different cube.
            var promptNameMappings = drillacrossDefinition.promptNameMappings;
            for(var j = 0; j < promptNames.length; j++){
                var value = '';
                var valueIndex = drillDownDimensions.indexOf(promptNameMappings[j]);
                if(valueIndex >= 0){
                    value = drillDownValues[valueIndex];
                }

                url += '&' + encodeURIComponent(promptNames[j]) + '=' + encodeURIComponent(value);
            }

            var dashID = drillacrossDefinition.dashboardId;

            // in the sidebar, just close the menu.  But from a report or fullscreen dash,
            // disable the page so they can't click until the dashboard launches
            var inSidebar = window.frames.self.name === 'mits_dashboard';
            var onclick = inSidebar?'hideCurrentMenu()':'disablePage()';

            var item = '';
            item += '<li onmouseover="flashDrillAcrossOptionsMouseOver(this);" onmouseout="flashDrillAcrossOptionsMouseOut(this);"';
            item += 'onclick=' +  onclick + '>';
            item += '<a target="mits_main" id="drillacross-'+ indentLevel + '" onclick="disableUnsavedWarning()"';
            if(i === 0) item += ' class="after_edge" ';  			// this goes along with the 'addedge' class used in the explore list
            item += 'dashboardId="' + drillacrossDefinition.dashboardId + '" ';  // include dashboard ID for selenium testing purposes

            // add the span with the prettified dashboard id
            // use double quotes to surround URL because encodeURIComponent() does not escape single quotes
            var escapedDescription = jQuery('<div>').text(drillacrossDefinition.dashboardDescription).html();
            item +=  'href="' + url + '">';
            item += '<span class="menuItem">' + escapedDescription + '</span></a></li>';

            listItemHtml += item;
        }
    }
    return listItemHtml;
};

module.exports = DrillAcrossHelper;


//////////////////
// WEBPACK FOOTER
// ./mits/DrillAcrossHelper.js
// module id = 24
// module chunks = 0